"use client";
import { TeamCard, TeamCardModal, TeamCardProps } from "@areahub/ui";
import {
  Box,
  Heading,
  SimpleGrid,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { blockComponents } from "components/individuals/mdx-components";
import { MDXRemote } from "next-mdx-remote";
import { useState } from "react";
import { fmtThemeColor } from "utils/index";

export const TeamGrid = ({ title, subtitle, gridItems, bg, color }: any) => {
  const disclosure = useDisclosure();
  const [person, setPerson] = useState<any>(null);
  const handlePersonClick = (person: TeamCardProps) => {
    setPerson(person);
    disclosure.onOpen();
  };
  return (
    <Box as="section" bg={fmtThemeColor(bg)} color={fmtThemeColor(color)}>
      <Box
        mx="auto"
        maxW={{ base: "xl", md: "7xl" }}
        px={{ base: "6", md: "8" }}
        py={{ base: "12", md: "20" }}
      >
        <Box textAlign="center">
          <Heading
            as={"h2"}
            fontSize={{
              base: 26,
              md: 34,
              lg: 38,
              xl: 45,
            }}
            letterSpacing="tight"
            mb="5"
            fontWeight="bold"
          >
            {title}
          </Heading>
          <Text
            as="div"
            fontSize={{
              lg: "lg",
            }}
            maxW="2xl"
            mx="auto"
          >
            {subtitle}
          </Text>
        </Box>
        <SimpleGrid
          mt="20"
          columns={{ base: 1, md: 2, lg: 3 }}
          spacingX="6"
          spacingY="16"
        >
          {gridItems.map((person: any, idx: number) => (
            <TeamCard
              key={idx}
              role={person?.role}
              image={person.photo}
              name={person.name}
              bio={person?.bio}
              hasBio={person.hasBio}
              onOpen={(props) => handlePersonClick(props)}
            />
          ))}
        </SimpleGrid>
      </Box>
      <TeamCardModal
        disclosure={disclosure}
        {...person}
        bio={
          person && <MDXRemote {...person?.bio} components={blockComponents} />
        }
      />
    </Box>
  );
};

export default TeamGrid;
